import { api } from '@/services'

export const findAll = (params) => {
  return api.get('/web/integration/findAll', { params })
}
export const findById = (id) => {
  return api.get(`/web/integration/${id}`)
}
export const create = (integration) => {
  return api.post('/web/integration/create', integration)
}
export const update = (integration) => {
  return api.post('/web/integration/update', integration)
}
export const deleteRequest = (id) => {
  return api.post(`/web/integration/delete/${id}`)
}